import React, { useEffect, useState, useRef } from 'react';
import { Badge, List, Space, Tag ,Row ,Col, Form, Popover, Typography, Descriptions, Tooltip, message, } from 'antd';
import moment from 'moment';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { postRequestApiByToken } from '../../../api';
import { getCountryCode, getFileExtension, getFileIconsObj } from '../../../utility';
import { FileIconsObj } from '../../../constant/globalConfig';
import Search from 'antd/lib/input/Search';
import ShareModal from './ShareModal';
import { InfoCircleTwoTone, StopOutlined } from '@ant-design/icons';
import TagSelection from '../../../components/tagSelection';
import DeleteModal from '../../otherDocuments/searchDocument/DocumentListing/DeleteModal';
import Avatar from 'antd/lib/avatar/avatar';
import LimitRequestModal from '../LimitRequestModal';
import { Base64 } from 'js-base64';

const DocumentListing = (lo_props) => {
    const { 
        lb_showDocTypeTag=false, 
        ls_headerText='Document Listing', 
        la_documentTypes, 
        lb_loading, 
        handlePaginationChange, 
        totalCount, 
        currentPage=1,  // Add currentPage prop with default value
        la_documentList, 
        getSearchData, 
        setLoading, 
        lb_showSearch=false, 
        handleSearch, 
        handleDocTypeChange=()=>{}, 
        la_actionAceess=['view', 'delete', 'share', 'bookmark', 'edit'], 
        isInput=false
    } = lo_props;
    const ls_userType = useSelector(content => content.commonReducer.user_type);
    const popoverRef = useRef();
    const [lb_shareModal, setShareModal] = useState(false)
    const [ls_documentId, setDocumentId] = useState()
    const [modalVisible, setModalVisible] = useState(false)
    const [lb_buttonLoading, setButtonLoading] = useState(false)
    const navigate = useNavigate();

    const handleBookedMarkButtonPress =async (item) => {
        setLoading(true);
        let lo_formData = {
          document_id: item?.id ,
          status: item.bookmarked ? 0 : 1 
        }
        const res = await postRequestApiByToken('addbookmark', lo_formData)
        if (res?.status =="Success") {
            message.success(res?.message);
            getSearchData()
        }
    }

    const handleRemoveBookedMarkButtonPress =async (item) => {
      setLoading(true);
      let lo_formData = {
        document_id: item?.document_id ,
        status: 0 
      }
      const res = await postRequestApiByToken('addbookmark', lo_formData)
      if (res?.status =="Success") {
          message.success('Document removed successfully');
          getSearchData()
      }
  }

    const getDocFileType = (row) => {
      if(!(row?.document_file || (row?.documents?.length && row?.documents[0]?.document_file))) return '';

      const docdata = row?.document_file || (row?.documents?.length && row?.documents[0]?.document_file);
      const extnsn = getFileExtension(docdata);
      return <div>{(docdata && extnsn) ? getFileIconsObj(extnsn) : docdata}</div>
    }

    const getFileDetails = (row) => {
        const extension = getFileExtension(row?.document_file || (row?.documents?.length && row?.documents[0]?.document_file));
        const fileElement = (row?.document_file || (row?.documents?.length && row?.documents[0]?.document_file) && extension) ? FileIconsObj[extension] : row?.document_file || (row?.documents?.length && row?.documents[0]?.document_file)
        return { extension, fileElement }
    }
    // const handleView =async (id) =>{
     
    //   let lo_formData = {
    //     document_id: id ,
    //     type: 'view'
    //   }
    //   const res = await postRequestApiByToken('documentaction', lo_formData)
    //   console.log('ressss',res);
    //   if (res?.status =="Success") {
    //   }
    // }

    const [ls_docAction, setForDocAction] = useState('')
    const handleView = async (id) => {
      let lo_formData = {
        document_id: id,
        type: 'view'
      }
      const res = await postRequestApiByToken('documentaction', lo_formData);
      console.log('ressss>>> handleView >>>', res);
      if (res?.status === "Success") {
        // navigate('/document/document-details', { state: { documentId: id } });

        const encryptedDocId = Base64.encode(id);
        const redirectUrl = `/document/document-details?documentId=${encryptedDocId}`;
        window.open(redirectUrl, '_blank');
      } else {
        message.error(res?.message || 'Access denied!');
        setForDocAction('request-for-limit')
      }
    }
    const getDocsDetailsContent = (lo_documentData={}) => {
        const items = [
          {
            key: '1',
            label: <Typography.Text type="secondary" strong><i className="fa fa-file-o docdtl-icn-color"></i> &nbsp;Document Name</Typography.Text>,
            children: lo_documentData?.title 
             || lo_documentData?.documents[0]?.title,
          },
          // {
          //   key: '2',
          //   label: <Typography.Text type="secondary" strong><i className="fa fa-book docdtl-icn-color"></i> &nbsp;Project Name</Typography.Text>,
          //   children: lo_documentData?.project?.project_name,
          // },
          {
            key: '3',
            label: <Typography.Text type="secondary" strong><i className="fa fa-calendar-o docdtl-icn-color"></i> &nbsp;Created Date</Typography.Text>,
            children: moment(lo_documentData?.created || lo_documentData?.documents[0]?.created).format('DD MMM YYYY'),
          },
          {
            key: '2',
            label: <Typography.Text type="secondary" strong><i className="fa fa-book docdtl-icn-color"></i> &nbsp;Sectors</Typography.Text>,
            children: (lo_documentData?.sectors || lo_documentData?.documents[0]?.sector)?.map((rowvalue, inx) => `${inx > 0 ? ', ':''} ${rowvalue.sector_name}`),
          },
          {
            key: '2',
            label: <Typography.Text type="secondary" strong><i className="fa fa-user docdtl-icn-color"></i> &nbsp;Client Name</Typography.Text>,
            children: (lo_documentData?.project?.contracted_by || lo_documentData?.documents[0]?.project?.contracted_by),
          },
          {
            key: '2',
            label: <Typography.Text type="secondary" strong><i className="fa fa-user docdtl-icn-color"></i> &nbsp;Implementing Agency</Typography.Text>,
            children: (lo_documentData?.project?.prj_for || lo_documentData?.documents[0]?.project?.prj_for),
          },
          // {
          //   key: '3',
          //   label: <Typography.Text type="secondary" strong><i className="fa fa-calendar-o docdtl-icn-color"></i> &nbsp;Last Downloaded</Typography.Text>,
          //   // children: '10/09/2013',
          //   children: '--',
          // },
          // {
          //   key: '4',
          //   label: <Typography.Text type="secondary" strong><i className="fa fa-file-text-o docdtl-icn-color"></i> &nbsp;No of Pages</Typography.Text>,
          //   children: '8',
          // },
          // {
          //   key: '4',
          //   label: <Typography.Text type="secondary" strong><i className="fa fa-file-text-o docdtl-icn-color"></i> &nbsp;Type</Typography.Text>,
          //   children: <>{getFileDetails(lo_documentData || lo_documentData)?.extension} {getFileDetails(lo_documentData)?.fileElement}</>,
          //   // children: <>Pdf <i className="fa fa-file-pdf-o"></i></>,
          // },
          // {
          //   key: '4',
          //   label: <Typography.Text type="secondary" strong><i className="fa fa-download docdtl-icn-color"></i> &nbsp;No of Downloads</Typography.Text>,
          //   children: '0',
          // },
          // {
          //   key: '4',
          //   label: <Typography.Text type="secondary" strong><i className="fa fa-eye docdtl-icn-color"></i> &nbsp;No of Views</Typography.Text>,
          //   children: '0',
          // },
        ];
        return (
        // <div className='col-xl-6 xl-100'>
            <Descriptions bordered column={1} size="small" labelStyle={{minWidth:180}}>
            {items.map((item) => (
                <Descriptions.Item key={item.key} label={item.label}>
                {item.children}
                </Descriptions.Item>
            ))}
            </Descriptions>
        // </div>
        )
    }

    const getActionForListing = (item, inx) => {
        const la_allActions = [
          <div className='first-li' >
            <div className='margin-first'>
              <i className="fa fa-file-o file-icon" style={{ color: "#4A1B97" }}></i> <Typography.Text type='secondary'> 
              {/* {la_documentTypes[inx]?.category_name} */}
              {item?.document_parent_category?.category_name || item?.documents[0]?.document_parent_category?.category_name}
              </Typography.Text>
            </div>
            <div className='margin-second'>
              <i className="fa fa-calendar" style={{ color: "#4A1B97" }}></i> <Typography.Text type='secondary'> Updated on: {moment(item?.modified_on || item?.documents[0]?.modified_on).format('DD MMM YY')}</Typography.Text>
            </div>
            {item?.shared_by && item?.shared_by[0] ? <> &nbsp;&nbsp;&nbsp;&nbsp;
              <div className='margin-second'>
                <i className="fa fa-user" style={{ color: "#4A1B97" }}></i> <Typography.Text type='secondary'>Shared by <strong>{item?.shared_by[0]?.name}</strong> on {moment(item?.shared_datetime).format('DD MMM YY')}</Typography.Text>
              </div>
            </> : <></>}

            {item?.share_with && item?.share_with[0] ? <> &nbsp;&nbsp;&nbsp;&nbsp;
              <div className='margin-second'>
                <i className="fa fa-user" style={{ color: "#4A1B97" }}></i> <Typography.Text type='secondary'>Shared with <strong>{item?.share_with[0]?.name}</strong> on {moment(item?.shared_datetime).format('DD MMM YY')}</Typography.Text>
              </div>
            </> : <></>}
          </div>,
      
          <div>{getDocFileType(item) || ''}</div>,
        ]

        if(la_actionAceess.includes('view')) la_allActions.push(
          // <div 
          // onClick={()=>handleView(item?.document_id || item?.id)}
          // >
        <Link 
          // to={'/document/document-details'} 
          // state={{ documentId: item?.document_id || item?.id }}
          onClick={()=>handleView(item?.document_id || item?.id)}
       >
            <i 
            // onClick={()=>handleView(item?.document_id || item?.id)}
            className="fa fa-eye text-secondary" style={{ fontSize: 18 }}></i>
         </Link>
          // </div>
          );
      
        if(ls_userType == 'admin' && la_actionAceess.includes('delete')) la_allActions.push(
        <i 
        onClick={()=>{setModalVisible(true);setDocumentId(item.id)}}
        className="fa fa-trash-o" 
        style={{ fontSize: 18 ,color: '#df0746',cursor:'pointer'}}></i>);
      
        if(la_actionAceess.includes('share')) la_allActions.push(
          <i onClick={()=>{setShareModal(true);setDocumentId(item.id)}}
          className="fa fa-share-alt text-secondary" style={{ fontSize: 18, cursor:"pointer" }}></i>);
      
        if(la_actionAceess.includes('bookmark')) la_allActions.push(<i className={item?.bookmarked ? 'icofont icofont-star' : 'icon-star'}
            onClick={() => handleBookedMarkButtonPress(item)}
            style={{ cursor: "pointer", fontSize: 18, color: item?.bookmarked ? '#f5cf00' : '#fff200' }}
          ></i>);

        if(la_actionAceess.includes('edit')) la_allActions.push(<Link to={'/document/add-document'} state={{ updateId: item.id }}>
        <i  className="fa fa-pencil"  style={{fontSize: 16, color: "rgb(40, 167, 69)" }}/>
        </Link> );

        if(la_actionAceess.includes('remove-fav')) la_allActions.push(<i className={'icofont icofont-star'}
        onClick={() => handleRemoveBookedMarkButtonPress(item)}
        style={{ cursor: "pointer", fontSize: 18, color: '#f5cf00' }}
        ></i>);
        
        // la_allActions.push(<Popover ref={popoverRef} placement="left" content={getDocsDetailsContent(item)} trigger="click" overlayClassName='col-xl-4 xl-100'>
        //         <a className="badge rounded-pill badge-secondary"
        //         href="#javascript">
        //         <i className="icofont icofont-info"></i></a>
        //     </Popover>);
    
        return la_allActions;
    }

    const returnCountryIcon = (cntryNm) => {
        const cntryCode = getCountryCode(cntryNm);
        if (cntryCode) {
          return <Tooltip title={cntryNm}>
                  <i className={`flag-icon flag-icon-${cntryCode.toLowerCase()}`} style={{ width: 45, fontSize: 16, padding: 5}}></i>
                </Tooltip>;
        } else {
          if (cntryNm) {
            return cntryNm
          } else {
            return <Avatar style={{width:45}} shape='square' icon={<StopOutlined />}/>;
          }
        }
    }
    
    const getCountryComponent = (item) => {
        if (item?.project?.country[0]?.country_name) {
          const ls_cntry = item?.project?.country[0]?.country_name;
          return  returnCountryIcon(ls_cntry) || '-------';
        } else if (item?.documents && item?.documents[0]?.project?.country[0]?.country_name) {
          const ls_cntry = item?.documents[0]?.project?.country[0]?.country_name;
          return  returnCountryIcon(ls_cntry) || '-------';
        } else {
          return  returnCountryIcon('');
        }
        
        // item?.project?.country[0]?.country_name ? returnCountryIcon(item?.project?.country[0]?.country_name) : '-------'
    }
    const handleDeleteButtonPress =async (row) => {
      setButtonLoading(true)
      const res = await postRequestApiByToken('deletedocument/'+ls_documentId)
      if (res?.status =="Success") {
        message.success(res?.message);
        getSearchData()
        setModalVisible(false)
      }
      setButtonLoading(false)
  };
    return (
        <>
        <div className="card height-equal">
            <div className="card-header card-header-border">
              <Row gutter={[0, 20]}>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <h5>{ls_headerText}</h5>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} className="pull-right">
                  {lb_showDocTypeTag ?
                    <Space size="middle">
                      {/* <div size="middle"> */}
                      <TagSelection onChange={handleDocTypeChange} la_documentTypes={la_documentTypes} isInput={isInput} />
                      {/* <Row>
                      {
                          la_documentTypes?.map((rowValue) => 
                          <Col xs={24} sm={24} md={8} lg={8} style={{ padding: 5, display: 'flex', justifyContent: 'flex-start' }}>

                          <Badge count={rowValue?.category_name ? parseInt(rowValue.documents_count) : 0} color={'#2fc3e5'} overflowCount={100000000000000}
                          // color='lime'
                          >
                          <Tag style={{cursor:"pointer"}} color="geekblue">{rowValue?.category_name}</Tag>
                          </Badge>
                      </Col>)
                      }
                      
                      </Row> */}
                    </Space> : <></>}
                  {lb_showSearch ?
                    <div>
                      <Row justify={'end'}>
                        <Col xs={24} sm={24} md={8} lg={8}>
                          <Search allowClear onChange={(e) => handleSearch(e.target.value)} placeholder="Search here..." />
                        </Col>
                      </Row>
                    </div>
                    : <></>}
                </Col>
              </Row>
            </div>
            <Row>
                <Col span={24} style={{ padding: 15 }}>
                    <div className="custom-doc-list-parent">
                    <List
                        itemLayout="vertical"
                        loading={lb_loading}
                        pagination={{
                            onChange: handlePaginationChange,
                            current: currentPage,
                            pageSize: 10,
                            showSizeChanger: false,
                            position: "bottom",
                            align: "end",
                            total: totalCount,
                        }}
                        dataSource={la_documentList}
                        renderItem={(item, inx) =>
                        (

                        <List.Item
                            key={item.icon}
                            style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                            actions={getActionForListing(item, inx)}
                            extra={getCountryComponent(item)}
                        >


                            <List.Item.Meta
                            // avatar={
                            // item?.project?.country[0]?.country_name ? returnCountryIcon(item?.project?.country[0]?.country_name) : ''
                            // }
                            title={<h6 className="mb-0 f-w-700"><i style={{ color: "#4a1b97" }} className="icofont icofont-law-document"></i> <Link onClick={()=>handleView(item?.document_id || item?.id)} style={{color: 'var(--bs-heading-color)'}}>{item.title || item?.documents[0]?.title}</Link> 
                                &nbsp;<Popover ref={popoverRef} placement="left" content={getDocsDetailsContent(item)} trigger="click" overlayClassName='col-xl-4 xl-100'>
                                <InfoCircleTwoTone style={{cursor:"pointer"}}/>
                                </Popover>
                        </h6>}
                            description={
                                <>
                                <p className='p-text'><i style={{ color: "#7534e08c" }}
                                    className="icofont icofont-ui-settings"></i>&nbsp;
                                    {item?.project?.project_name || (item?.documents && item?.documents[0]?.project?.project_name)}</p>
                                {/* <div style={{display:'flex',flexDirection:'row'}}>
                                    <div style={{ marginInlineEnd: 20 }}>
                                    <i className="fa fa-calendar" style={{ color: "#4A1B97" }}> Updated on: </i> :{moment(item.modified_on).format('DD MMM YY')}
                                </div>
                                <div>
                                    <i className="fa fa-file-o" style={{ color: "#4A1B97" }}></i> : {la_documentTypes[inx]?.category_name}
                                </div> 
                                    </div> */}

                                </>
                            }
                            />
                        </List.Item>
                        )}
                    />

                    </div>
                </Col>
            </Row>
        </div>
        <ShareModal
          visible={lb_shareModal}
          onCancel={() => setShareModal(false)}
          ls_documentId={ls_documentId}
        // onOk={handleReviewButtonPress}
        // loading={lb_buttonLoading}
        />
        <DeleteModal
          visible={modalVisible}
          title="Alert"
          content="Are you absolutely certain you wish to delete this document?"
          onCancel={() => setModalVisible(false)}
          onOk={handleDeleteButtonPress}
          loading={lb_buttonLoading}
        />

        <LimitRequestModal {...{setForDocAction, ls_docAction}} />
        </>
    )
}

export default DocumentListing